{
    "Para1ChartingEnabled": "U kunt kiezen of afdrukbare uitvoer voor rapporten een samenvattingskop bevat met informatie voor het bijbehorende rapport, en of zowel de inhoud van de rapportrij in tabelvorm en\/of een diagramweergave wordt weergegeven.",
    "Para1ChartingDisabled": "U kunt kiezen of afdrukbare uitvoer voor rapporten een samenvattingskop bevat met informatie voor het bijbehorende rapport.",
    "PrintableOutputIncludesLabel": "Afdrukuitvoeropties",
    "ShowSummaryHeaderLabel": "Toon samenvattingskop:",
    "Para2": "U kunt selecteren of er een kop- en\/of voettekstrij wordt weergegeven voor de getabelleerde gegevens van afdrukbare en\/of geëxporteerde rapportuitvoer, naast het kiezen of de inhoudsgegevensrijen van het rapport daadwerkelijk worden opgenomen.",
    "TableAndChartIfAvailable": "Gegevens in tabelvorm + grafiek (indien beschikbaar)",
    "TableAndChart": "Gegevens in tabelvorm + grafiek (altijd)",
    "TableOnly": "Alleen gegevens in tabelvorm",
    "ChartOnly": "Alleen grafiek",
    "PrintOutput_SectionHeader": "Afdrukuitvoeropties",
    "NAME": "PrintOutput"
}